Ext.define('SA.BarChartViewController', {
    constructor({model, activeState}) {
        this.model = model;
        this.activeState = activeState;

        this.toolbar = new SA.view.BarChartToolbar({model});
        this.view = Ext.widget({xtype: 'bar-chart-view', projectView: model});
        this.projectView = SA.ProjectView.createHidden(this.view);

        this.initEvents();
    },

    initEvents() {
        this.model.on('remove', this.onModelDelete, this);

        this.activeState.onActive(this.onActive, this);

        this.toolbar.on('click:viewActions:edit', this.onToolbarViewActionsEditClick, this);
        this.toolbar.on('click:viewActions:createDataTable', this.onToolbarViewActionsCreateDataTableClick, this);
        this.toolbar.on('click:viewActions:delete', this.onToolbarViewActionsDeleteClick, this);
        this.toolbar.on('activate:exportBtn', this.onActivateExportBtn, this);
    },

    onActivateExportBtn(toolbarButton) {
        var config = new SA.ChartExportConfig({model: this.model, svgPromise: this.view.getSvg()});

        Ext.widget({xtype: 'arrow-export-menu', config, toolbarButton});
    },

    onActive() {
        SA.ProjectViewToolbar.setToolbar(this.toolbar);
        SA.ProjectView.show(this.projectView);
    },

    onModelDelete() {
        this.toolbar.destroy();
        this.projectView.destroy();
    },

    onToolbarViewActionsCreateDataTableClick() {
        var locations = this.model.getLocations(),
            attributes = this.model.getAttributes(),
            censusRelease = this.model.getCensusRelease(),
            comparison = this.model.getProject().addViewWithParams({type: 'comparison', params: {locations, attributes, censusRelease}});

        SA.AppController.showProjectView(comparison);
    },

    onToolbarViewActionsDeleteClick() {
        SA.AppController.deleteView(this.model);
    },

    onToolbarViewActionsEditClick() {
        SA.AppController.showProjectView(this.model, 'edit');
    }
});